module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAALxJREFUOBFjYICC////SwDxPiBeB8SJMHEYDRKDyoHUSMDEGYGcRiBHCYhFgPgwEC8H4u1AfBqIkYEpkOMJxJFAbAvEb4D4LgPQgE1ABohWBuLtQNwGxNUgMWQAEoPKgdQog+SA9Ca4AVABeaCgHhAzIWuGyjFB5eRhckD+JpAXbgEFVsMESaRDWYAaHgLxTBI1wpSbgQz4zsjI+AgmQgoNdP13DL+SYgBI7agBwyIMQAkJlJwXkxr/UPWMAJHkci0tkxvPAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/layouts/PageLayout/assets/calendar-white.png
// module id = ./src/layouts/PageLayout/assets/calendar-white.png
// module chunks = 1